import Vue from 'vue'
import VueGtag from 'vue-gtag'

if (process.env.gtagID) {
  Vue.use(VueGtag, {
    config: { id: process.env.gtagID },
  })
}
